export interface LoginRequest {
  username: string;
  password: string;
}

export interface SignUpRequest{
  username: string;
  password: string;
  confirmPassword: string;
}

export interface RegisterOperatorRequest {
  token: string;
  username: string;
  password: string;
  confirmPassword: string;
}
export interface LoginResponse {
  token: string;
  refreshToken: string;
  user: UserInfo;
  permissions: string[]
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface UserInfo{
  username: string;
  role: RoleInfo;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phoneNumber?: string;
}

export enum RoleInfo{
  Admin = 1,
  Customer = 2,
  Operator = 3
}

export interface GoogleLoginRequest {
  idToken: string;
}

export interface MenuItemInfo {
  label: string;
  icon: string;
  route: string;
  requiredPermission?: string;
}
